import cssVars from 'css-vars-ponyfill';

cssVars({
  // Treat all browsers as legacy
  onlyLegacy: false,

  // DEMO: Toggles to see results
  // ----------------------------
  // preserveStatic: false,
  // preserveVars: true,
  // updateURLs: false,
  // variables: { '--color': 'purple' },
  // ----------------------------

});
